// ======================================================================
// FILE:
// src/modules/wms/reports/services/reportService.js
//
// MODULE:
// Work Management System (WMS)
//
// FEATURE:
// WMS Reports APIs
// ======================================================================

import axiosClient from "../../../../api/axiosClient";


// ======================================================================
// OPEN WORK REGISTER
// ======================================================================

const getOpenWorkRegister = async (params = {}) => {

  const res = await axiosClient.get(
    "/api/wms/reports/open-work-register",
    {
      params,
    }
  );

  return res.data.data;

};


// ======================================================================
// EXPORT EXCEL
// ======================================================================

const exportOpenWorkRegisterExcel = async (
  params = {}
) => {

  const res = await axiosClient.get(

    "/api/wms/reports/open-work-register/export/excel",

    {

      params,

      responseType: "blob",

    }

  );

  return res.data;

};


// ======================================================================
// EXPORT PDF
// ======================================================================

const exportOpenWorkRegisterPdf = async (
  params = {}
) => {

  const res = await axiosClient.get(

    "/api/wms/reports/open-work-register/export/pdf",

    {

      params,

      responseType: "blob",

    }

  );

  return res.data;

};


// ======================================================================
// EXPORT CSV
// ======================================================================

const exportOpenWorkRegisterCsv = async (
  params = {}
) => {

  const res = await axiosClient.get(

    "/api/wms/reports/open-work-register/export/csv",

    {

      params,

      responseType: "blob",

    }

  );

  return res.data;

};


// ======================================================================
// EXPORTS
// ======================================================================

const reportService = {

  getOpenWorkRegister,

  exportOpenWorkRegisterExcel,

  exportOpenWorkRegisterPdf,

  exportOpenWorkRegisterCsv,

};

export default reportService;